import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentBooking, setCurrentBooking] = useState(null);
  const [paymentOrder, setPaymentOrder] = useState(null);

  const clearBooking = () => {
    setSelectedEvent(null);
    setSelectedDate(null);
    setCurrentBooking(null);
    setPaymentOrder(null);
  };

  return (
    <BookingContext.Provider value={{
      selectedEvent, setSelectedEvent,
      selectedDate, setSelectedDate,
      currentBooking, setCurrentBooking,
      paymentOrder, setPaymentOrder,
      clearBooking,
    }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
